import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'querystring';
import { t } from 'utils/translates';

class SearchFormRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    if (this.state.searchValue.length > 0) {
      this.context.router.history.push({
        pathname: '/help/reference-information/search',
        search: `?${qs.stringify({ content: this.state.searchValue })}`
      });
    }
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h1 className="page-header hidden-xs">
            <i className="fa fa-question-circle fa-lg" /> {t('Помощь')}
          </h1>
          <form className="form-inline" onSubmit={this.handleSubmit}>
            <div className="form-group pull-right visible-sm m-b-0">
              <button
                className="btn btn-default"
                data-toggle="sidebar-r"
                type="button"
              >
                <span>{t('Меню')}</span>
              </button>
            </div>
            <div className="form-group form-group-block m-b-0">
              <label className="control-label sr-only" htmlFor="content">
                {t('Поиск по справке')}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  id="content"
                  placeholder={t('Поиск по справке')}
                  type="text"
                  value={this.state.searchValue}
                  onChange={e => {
                    this.setState({
                      searchValue: e.target.value
                    });
                  }}
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-default text-overflow_no"
                    type="submit"
                  >
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

SearchFormRedirect.contextTypes = {
  router: PropTypes.shape()
};

SearchFormRedirect.propTypes = {};

export default SearchFormRedirect;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentMain/SearchFormRedirect/SearchFormRedirect.js